/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Trial_BannerInputs */

const en_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial accounts are limited to videos under 5 minutes. Activate your account to remove this limit.`)
};

const fr_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les comptes d'essai sont limités aux vidéos de moins de 5 minutes. Activez votre compte pour supprimer cette limite.`)
};

const de_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testkonten sind auf Videos unter 5 Minuten beschränkt. Aktivieren Sie Ihr Konto, um diese Beschränkung aufzuheben.`)
};

const it_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli account di prova sono limitati a video di durata inferiore a 5 minuti. Attiva il tuo account per rimuovere questo limite.`)
};

const ru_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В пробных аккаунтах разрешены видеоролики продолжительностью менее 5 минут. Активируйте свой аккаунт, чтобы снять это ограничение.`)
};

const es_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cuentas de prueba están limitadas a vídeos de menos de 5 minutos. Activa tu cuenta para eliminar esta limitación.`)
};

const zh_cn2_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用账号只能观看时长不超过5分钟的视频。激活账号即可解除此限制。`)
};

const ja_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルアカウントでは、5分未満の動画しかアップロードできません。この制限を解除するには、アカウントを有効化してください。`)
};

const hi_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रायल अकाउंट में 5 मिनट से कम अवधि के वीडियो ही अपलोड किए जा सकते हैं। इस सीमा को हटाने के लिए अपना अकाउंट एक्टिवेट करें।`)
};

const pt_pt2_sd_trial_banner = /** @type {(inputs: Sd_Trial_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As contas de teste são limitadas a vídeos com menos de 5 minutos. Ative sua conta para remover essa limitação.`)
};

/**
* | output |
* | --- |
* | "Trial accounts are limited to videos under 5 minutes. Activate your account to remove this limit." |
*
* @param {Sd_Trial_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_trial_banner = /** @type {((inputs?: Sd_Trial_BannerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Trial_BannerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sd_trial_banner(inputs)
	if (locale === "de") return de_sd_trial_banner(inputs)
	if (locale === "it") return it_sd_trial_banner(inputs)
	if (locale === "ru") return ru_sd_trial_banner(inputs)
	if (locale === "es") return es_sd_trial_banner(inputs)
	if (locale === "zh-CN") return zh_cn2_sd_trial_banner(inputs)
	if (locale === "ja") return ja_sd_trial_banner(inputs)
	if (locale === "hi") return hi_sd_trial_banner(inputs)
	if (locale === "pt-PT") return pt_pt2_sd_trial_banner(inputs)
	return en_sd_trial_banner(inputs)
});